import api from './index';

const profileAPI = {
  // Get applicant profile with user data
  getProfile: (applicantId) => {
    return api.get(`/applicants/${applicantId}?include_user=true`);
  },
  
  // Get user data separately if needed
  getUserData: () => {
    return api.get('/applicants/user');
  },
  
  // Update applicant profile
  updateProfile: (applicantId, profileData) => {
    return api.put(`/applicants/${applicantId}`, profileData);
  },

  deleteAccount: (applicantId) => {
    return api.delete(`/applicants/${applicantId}`);
  },

  // Get all available skills from the shared catalog
  getSkills: () => {
    return api.get('/skills', {
      headers: {
        'Accept': 'shared api; version=1'
      }
    });
  },

  // Get current applicant skills
  getApplicantSkills: () => {
    return api.get('/applicants/skills');
  },

  // Add or update a current applicant skill
  addApplicantSkill: (skillId, data = {}) => {
    return api.post('/applicants/skills', {
      skill_id: skillId,
      has_experience: true,
      responded_at: new Date().toISOString(),
      ...data
    });
  },

  updateApplicantSkill: (applicantSkillId, data) => {
    return api.put(`/applicants/skills/${applicantSkillId}`, data);
  },

  // Remove a current applicant skill
  removeApplicantSkill: (applicantSkillId) => {
    return api.delete(`/applicants/skills/${applicantSkillId}`);
  },

  // Applicant work history (applicants_history_companies in rebase_server).
  // Each entry: { id, job_title, year_start, month_start, year_end, month_end,
  // still_working, history_company: { id, name } }.
  getWorkHistory: () => {
    return api.get('/applicants/history_companies');
  },

  // Create a work-history entry. Pass `name` (company) and the server
  // finds-or-creates the HistoryCompany, or pass `history_company_id` directly.
  addWorkHistory: (data) => {
    return api.post('/applicants/history_companies', data);
  },

  updateWorkHistory: (id, data) => {
    return api.put(`/applicants/history_companies/${id}`, data);
  },

  removeWorkHistory: (id) => {
    return api.delete(`/applicants/history_companies/${id}`);
  },

  // Applicant education entries (applicants_educations). Each references catalog
  // rows by id: { id, education_institution:{id,name}, education_degree:{id,name},
  // education_course:{id,name}, grade, with_honors, year_start, year_end }.
  getEducations: () => {
    return api.get('/applicants/educations');
  },
  addEducation: (data) => {
    return api.post('/applicants/educations', data);
  },
  updateEducation: (id, data) => {
    return api.put(`/applicants/educations/${id}`, data);
  },
  removeEducation: (id) => {
    return api.delete(`/applicants/educations/${id}`);
  },

  // Applicant language entries (applicants_languages): { id, language:{id,name},
  // reading, writing, verbal } — the three levels are integers (see the server's
  // get_single_display_text scale).
  getLanguages: () => {
    return api.get('/applicants/languages');
  },
  addLanguage: (data) => {
    return api.post('/applicants/languages', data);
  },
  updateLanguage: (id, data) => {
    return api.put(`/applicants/languages/${id}`, data);
  },
  removeLanguage: (id) => {
    return api.delete(`/applicants/languages/${id}`);
  },
  
  // Upload CV
  uploadCV: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    return api.post('/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  createResume: (data) => {
    return api.post('/applicants/resume', data, { responseType: 'blob' });
  },
  
  // Check if applicant has recent CV
  checkRecentCV: () => {
    return api.get('/files/check_recent');
  }
};

export default profileAPI;
